/**
 *  群发弹出框
 *
 */
'use strict';
angular.module('weixinLayoutEditorModule', []).controller('weixinLayoutEditorController', ['$scope', 'draftParams', '$modalInstance', 'trsHttpService', '$q', 'modalDialog', 'trsspliceString', 'wechatBtnService', '$state',
    function($scope, draftParams, $modalInstance, trsHttpService, $q, modalDialog, trsspliceString, wechatBtnService, $state) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                massArray: draftParams.items,
                picwordid: draftParams.picwordid,
            };
            $scope.status = {
                rzhItem: {},
            };
        }

        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            queryCoverPic();
            getRzh();
        }

        /**
         * [getTopUrl description] 取得封面图
         * @param  {[type]} item [description]
         * @return {[type]}       [description]
         */
        $scope.getTopUrl = function(item) {
            if (item.CoverPic) {
                return item.CoverPic.TOPSRCPICURL ? item.CoverPic.TOPSRCPICURL : item.CoverPic.SRCPICURL;
            } else {
                return '';
            }
        };

        /**
         * [findDocDetails description]群发历史获取稿件详情
         * @param  {[type]} items [description]
         * @return {[type]}       [description]
         */
        function findDocDetails(items) {
            var deferred = $q.defer();
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'findDocDetails',
                DocIds: items.SENDINGORDER,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.massArray = data;
                deferred.resolve($scope.data.massArray);
            });
            return deferred.promise;
        }

        /**
         * [queryCoverPic description]获取封面图
         * @return {[type]} [description]
         */
        function queryCoverPic() {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'queryCoverPic',
                DocIds: trsspliceString.spliceString($scope.data.massArray, 'METADATAID', ','),
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                for (var i = 0; i < $scope.data.massArray.length; i++) {
                    for (var j = 0; j < data.length; j++) {
                        if ($scope.data.massArray[i].METADATAID == data[j].DOCID) {
                            $scope.data.massArray[i].CoverPic = data[j];
                        }
                    }
                }
            });
        }

        /**
         * [sort description]排序
         * @return {[type]} [description]
         */
        $scope.sort = function() {
            $scope.status.isSort = true;
        };

        /**
         * [return description]排序返回
         * @return {[type]} [description]
         */
        $scope.return = function() {
            $scope.status.isSort = false;
        };

        /**
         * [changeSort description]移动方法
         * @param  {[type]} flag  [description]
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        $scope.changeSort = function(flag, index) {
            var indexItem;
            if (flag == 'down') {
                indexItem = $scope.data.massArray[index];
                indexItem.showBq = false;
                $scope.data.massArray[index] = $scope.data.massArray[index + 1];
                $scope.data.massArray[index + 1] = indexItem;
            } else {
                indexItem = $scope.data.massArray[index];
                indexItem.showBq = false;
                $scope.data.massArray[index] = $scope.data.massArray[index - 1];
                $scope.data.massArray[index - 1] = indexItem;
            }
        };

        /**
         * [addItems description] 增加图文
         * @return {[type]} [description]
         */
        $scope.addItems = function() {
            wechatBtnService.weixinAddComp($scope.data.massArray, function(array) {
                $scope.data.massArray = $scope.data.massArray.concat(array);
                queryCoverPic();
            });
        };
        // 删除
        $scope.deleteItem = function(index) {
            $scope.data.massArray.splice(index, 1);
        };

        /**
         * [confirm description] 提交
         * @return {[type]} [description]
         */
        $scope.save = function() {
            if ($scope.data.massArray.length > 8) {
                modalDialog.alertType('稿件不能超过8条', '', 'warning', 'confirm', function() {
                });
                return false;
            }
            var params = {
                DocIds: trsspliceString.spliceString($scope.data.massArray, 'METADATAID', ','),
                methodname: 'saveZuBanMessage',
                serviceid: 'mlf_wechatgroupsend',
            };
            if ($scope.data.picwordid) { // 已组版编辑
                params.WechatCardMessageId = $scope.data.picwordid;
                params.methodname = 'updateZuBanMessage';
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('组版成功', '', 'success', false, function() {
                    $modalInstance.close('SUCCESS');
                });
            });
        };

        /**
         * [getRzh description]
         *
         * @return  {[type]}   [return description]
         */
        function getRzh() {
            var params = {
                MediaType: 4,
                PAGESIZE: 1000,
                methodname: 'queryWebSitesByMediaType',
                serviceid: 'mlf_mediasite',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.channels = data.DATA;
                $scope.data.channels.map((item) => {
                    if (item.CHANNELID == $state.params.wxchannelid) {
                        $scope.status.rzhItem = item;
                    }
                });
            });
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $scope.status.isFirstClick = false;
            $modalInstance.dismiss();
        };
        // 保存并预览
        $scope.saveAndPreview = function() {
            if ($scope.data.massArray.length > 8) {
                modalDialog.alertType('稿件不能超过8条', '', 'warning', 'confirm', function() {
                });
                return false;
            }
            // var params = {
            //     DocIds: trsspliceString.spliceString($scope.data.massArray, 'METADATAID', ','),
            //     methodname: 'saveZuBanMessage',
            //     serviceid: 'mlf_wechatgroupsend',
            // };
            // if ($scope.data.picwordid) { // 已组版编辑
            //     params.WechatCardMessageId = $scope.data.picwordid;
            //     params.methodname = 'updateZuBanMessage';
            // }
            // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
            wechatBtnService.wxPreview($scope.data.massArray, 'preview', '', function(data) {
                if (data === 'success') {
                    $modalInstance.close();
                }
            }, $scope.data.picwordid);
            // });

        };
    },
]);
